import { render, staticRenderFns } from "./TelaAvisoEmail.vue?vue&type=template&id=4bc47cf1&scoped=true&"
import script from "./TelaAvisoEmail.vue?vue&type=script&lang=js&"
export * from "./TelaAvisoEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc47cf1",
  null
  
)

export default component.exports